<template>
  <div class="contact thanks bg-white">
     <navbar />
      <div class="lower-mv" :style="lowermv">
        <h2>{{ $t('contact') }}</h2>
      </div>
      <section class="wrapper">
        <p class="txt">{{ $t('transmission_complete') }}<br>
          <span v-html="$t('contact_if_confirmed')"></span></p>
        <p class="topLink">
          <a @click="home" class="brown_btn"><span>TOP</span></a>
        </p>
      </section>
     <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      }
    }
  },
  components: {
    navbar,
    footerClient
  },
  methods: {
    home: function () {
      this.$router.push({ name: 'Client Property' }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    }
  }
}
</script>
